import React from "react";
import {
  FeatureImageStyle,
  FeatureItemModel,
  LinkStyle,
  ButtonUrlType,
  LeadGenStyle,
} from "../Models/PageCreatorPage";
import LeadGenFeatureItem from "./LeadGenFeatureItem";

interface LeadGenFeatureItemContainerProps {
  imageStyle: FeatureImageStyle;
  item: FeatureItemModel;
  linkStyle: LinkStyle;
  sectionStyle?: LeadGenStyle;
}

const LeadGenFeatureItemContainer = ({
  imageStyle,
  item,
  linkStyle,
  sectionStyle,
}: LeadGenFeatureItemContainerProps) => {
  return (
    <>
      {linkStyle === LinkStyle.button || linkStyle === LinkStyle.text ? (
        <a
          href={item.buttonUrl}
          target={
            item.buttonUrlType === ButtonUrlType.section ? "_self" : "_blank"
          }
        >
          <LeadGenFeatureItem
            imageStyle={imageStyle}
            item={item}
            linkStyle={linkStyle}
            sectionStyle={sectionStyle}
          />
        </a>
      ) : (
        <LeadGenFeatureItem
          imageStyle={imageStyle}
          item={item}
          linkStyle={linkStyle}
          sectionStyle={sectionStyle}
        />
      )}
    </>
  );
};

export default LeadGenFeatureItemContainer;
